export function processingCode(content: TContent): TContent {
  return {
    ...content.children[0],
  };
}
